import requester from "api/requester"
import { IWaterAPI, IDailyWater } from "./waterSlice.types"

const waterAPI: IWaterAPI = {
  addWater(payload: IDailyWater): Promise<IDailyWater> {
    return requester.post("/water-tracking/add", payload)
  },

  updateWater(payload: IDailyWater): Promise<IDailyWater> {
    return requester.post("/water-tracking", payload)
  },

  getDailyWater(date: string, signal?: AbortSignal): Promise<IDailyWater> {
    return requester.get("/water-tracking", { date }, { signal })
  },
}

export default waterAPI
